import { render } from "./NotificationsView.vue?vue&type=template&id=07d0dce8&scoped=true"
import script from "./NotificationsView.vue?vue&type=script&lang=ts"
export * from "./NotificationsView.vue?vue&type=script&lang=ts"

import "./NotificationsView.vue?vue&type=style&index=0&id=07d0dce8&lang=stylus&scoped=true"
script.render = render
script.__scopeId = "data-v-07d0dce8"

export default script